import { ClientCodes, ClientNames, VendorCodes } from '../enums';
import { getClientCode, getClientName, getClientVendorCode } from '../util';
import { useIsHubSite } from './use-is-hub-site';
var useIsClientByClientName = function(clientNameToMatch) {
    return getClientName() === clientNameToMatch;
};
var useIsClientByClientCode = function(clientCodeToMatch) {
    return getClientCode() === clientCodeToMatch;
};
var useIsClientByVendorCode = function(vendorCode) {
    return getClientCode() === null && getClientVendorCode() === vendorCode;
};
export var useIsClientKpmg = function() {
    return useIsClientByClientCode(ClientCodes.KPMG);
};
export var useIsClientCenovus = function() {
    return useIsClientByClientCode(ClientCodes.CENOVUS);
};
export var useIsClientBMO = function() {
    return useIsClientByClientCode(ClientCodes.BMO);
};
export var useIsClientDemoClient = function() {
    return useIsClientByClientCode(ClientCodes.DemoClient);
};
export var useIsClientGwDemoClient = function() {
    return useIsClientByClientCode(ClientCodes.GwDemoClient);
};
export var useIsClientProcom = function() {
    return useIsHubSite() && getClientVendorCode() === VendorCodes.PCGL;
};
export var useIsClientDemoCorp = function() {
    return useIsClientByClientCode(ClientCodes.DemoCorp);
};
export var useIsClientProcomTeam = function() {
    return useIsClientByClientCode(ClientCodes.ProcomTeam);
};
export var useIsClientIMS = function() {
    return useIsClientByClientCode(ClientCodes.IMS);
};
export var useIsClientHCMWorks = function() {
    return useIsClientByClientCode(ClientCodes.HCMWorks);
};
export var useIsClientFlexTrack = function() {
    return useIsClientByClientCode(ClientCodes.Flextrack);
};
export var useIsClientEy = function() {
    return useIsClientByClientCode(ClientCodes.EY);
};
export var useIsGorillaWorks = function() {
    return useIsClientByClientName(ClientNames.GorillaWorks);
};
export var useIsVendorPCGL = function() {
    return useIsClientByVendorCode(VendorCodes.PCGL);
};
export var useIsVendorBridgeWorks = function() {
    return useIsClientByVendorCode(VendorCodes.BridgeView);
};
export var useIsVendorSymbiotic = function() {
    return useIsClientByVendorCode(VendorCodes.Symbiotic);
};
export var useIsVendorSoftChoice = function() {
    return useIsClientByVendorCode(VendorCodes.SFTCHE);
};
export var useIsVendorDemoSandbox = function() {
    return useIsClientByVendorCode(VendorCodes.DEMOSANDBOX);
};
export var useIsVendorDemo = function() {
    return useIsClientByVendorCode(VendorCodes.DEMO);
};
export var useIsVendorGw = function() {
    return useIsClientByVendorCode(VendorCodes.GW);
};
export var useIsVendorJarvis = function() {
    return useIsClientByVendorCode(VendorCodes.Jarvis);
};
export var useIsVendorICQEnabled = function() {
    return getClientCode() === null && [
        VendorCodes.PCGL,
        VendorCodes.GW,
        VendorCodes.DEMO
    ].includes(getClientVendorCode());
};
